/**
 * Created by Rumyantsev Daniil on 19.03.2018.
 */
import { Pipe, PipeTransform } from '@angular/core';
/**
 * Возвращает строку template - если указана, если нет - "Нет данных",
 * если обьект равен null или NaN, иначе возваращет обьект
 *
 * Usage:
 *   value | checkNumData : template
 *
 * Example:
 *   {{ -420.42 | checkNumData}}
 *   formats to: 420.42
 *   {{ -420.42 | checkNumData}}
 *   formats to: 420.42
 *   {{ null | checkNumData}}
 *   formats to: "Нет данных"
 *   {{ null | checkNumData : "Неизвестно"}}
 *   formats to: "Неизвестно"
 */
@Pipe({name: 'checkNumData'})
export class CheckNumberDataPipe implements PipeTransform {

  transform(value: number, template?: string): number | string {

     if(value == null || isNaN(value)) {
      return template == null ? "Нет данных" : template;
     }

     return value;
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/check-number-data.pipe.ts